import { getProviderSquareIconFileName } from '@/utils/provider-square-icon';
import { cn } from '../../../utils/ui';

interface ProviderIconProps {
  providerId: string;
  providerDisplayName: string;
  className?: string;
}

export function ProviderIcon({ providerId, providerDisplayName, className }: ProviderIconProps) {
  const accessibleName = providerId === 'novu' ? 'pingr-notify Inbox' : providerDisplayName;

  return (
    <img
      src={`/images/providers/light/square/${getProviderSquareIconFileName(providerId)}.svg`}
      alt={accessibleName}
      className={cn('h-6 w-6 object-contain', className)}
    />
  );
}
